var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M7.5 1.666a3.962 3.962 0 0 0-3.958 3.958c0 2.142 1.675 3.875 3.858 3.95a.673.673 0 0 1 .183 0h.059a3.948 3.948 0 0 0 3.816-3.95A3.962 3.962 0 0 0 7.5 1.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M11.733 11.79c-2.325-1.55-6.116-1.55-8.458 0-1.058.71-1.642 1.668-1.642 2.693 0 1.025.584 1.975 1.634 2.675 1.166.783 2.7 1.175 4.233 1.175 1.533 0 3.067-.392 4.233-1.175 1.05-.709 1.634-1.659 1.634-2.692-.009-1.025-.584-1.975-1.634-2.675Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M16.658 6.116a2.983 2.983 0 0 1-2.608 3.225h-.042c-.05 0-.1 0-.141.017a2.99 2.99 0 0 1-2.109-.692 3.814 3.814 0 0 0 1.25-3.167 3.867 3.867 0 0 0-.641-1.816 2.994 2.994 0 0 1 4.292 2.433Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M18.325 13.824c-.067.809-.584 1.508-1.45 1.983-.834.459-1.883.676-2.925.65.6-.541.95-1.216 1.017-1.933.083-1.033-.409-2.025-1.392-2.816a6.884 6.884 0 0 0-1.917-1.05c1.842-.534 4.159-.175 5.583.975.767.616 1.159 1.391 1.084 2.191Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135.03 4.885 3.36) scale(9.61638 7.25917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(146.711 4.455 7.449) scale(12.0627 8.35554)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(129.381 7.195 5.756) scale(6.65117 4.92453)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(137.844 6.756 8.856) scale(7.7389 5.81315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b029a2b6363c893416fcbe5fa1890722.svg";
export { ForwardRef as ReactComponent };